import React, { useEffect, useState } from "react";
import { isEmpty, isNil } from "ramda";

import { MapContainer, TileLayer, Marker, Polyline, useMap } from "react-leaflet";
import { IS_ONLINE, MAP_TYPES } from "../../../../../config/configmap";
import { Icon } from "leaflet";

const MapAlert = ({ assetData, points, alert, intl }) => {
  const mapType = "regular";
  const [polyline, setPolyline] = useState([]);
  const [alertPosition, setAlertPosition] = useState([]);

  const customIcon = new Icon({
    iconUrl: require(`../../../../../images/Uptech-marker-alerts-icon-high-${alert.application}.png`),
    iconSize: [60, 60],
    iconAnchor: [27, 60],
  });

  useEffect(() => {
    if (!isNil(alert) && !isNil(points) && isEmpty(polyline)) {
      const assetChannelPoints = points.data[`${alert.asset}${alert.channel}`];
      const newPoints = [];
      if (!isNil(assetChannelPoints)) {
        for (let pIndex = 0; pIndex < assetChannelPoints.p_indexes.length; pIndex++) {
          newPoints.push(assetChannelPoints.points[assetChannelPoints.p_indexes[pIndex]]);
        }
        setAlertPosition([
          points.data[`${alert.asset}${alert.channel}`].points[alert.startIndex].latitude,
          points.data[`${alert.asset}${alert.channel}`].points[alert.startIndex].longitude,
        ]);
        setPolyline(newPoints);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alert, points]);

  function ChangeView() {
    const mapView = useMap();
    useEffect(() => {
      mapView.dragging.enable();
      mapView.scrollWheelZoom.enable();
      mapView.doubleClickZoom.enable();
      mapView.boxZoom.enable();
      mapView.keyboard.enable();

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mapView]);

    if (!isEmpty(alertPosition)) {
      mapView.setMaxBounds(null);
      mapView.setView(alertPosition, 15, { reset: false });
    }

    return null;
  }

  return (
    <MapContainer id="map-for-alert" style={{ width: "50%", height: "30rem" }} center={assetData.centroid} zoom={11}>
      <TileLayer
        attribution={IS_ONLINE ? "Google Maps" : "OpenStreetMap"}
        url={MAP_TYPES.find((type) => type.value === mapType).tileLayer}
        maxZoom={18}
        subdomains={["mt0", "mt1", "mt2", "mt3"]}
      />
      <ChangeView />
      {polyline.map((line, lineIndex) => {
        if (lineIndex === 0) return null;
        return (
          <Polyline
            key={`${alert.application}-${alert.asset}-${lineIndex}`}
            positions={[
              [polyline[lineIndex - 1].latitude, polyline[lineIndex - 1].longitude],
              [line.latitude, line.longitude],
            ]}
            weight={5}
            color={"#02429c"}
          ></Polyline>
        );
      })}
      {!isNil(alert) && !isEmpty(alertPosition) && (
        <Marker key={assetData.name} position={alertPosition} icon={customIcon}></Marker>
      )}
    </MapContainer>
  );
};

export default MapAlert;
